module.exports = __webpack_public_path__ + "static/media/22pic.695d7847.jpg";